import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectRequisites } from "./ui";

export function ProjectRequisitesRoute(...rest: RouteObject[]): RouteObject {
  return {
    path: routes.project.requisites(),
    element: createElement(ProjectRequisites),
    children: rest,
  };
}
